import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { RuleGroup } from 'app/admin/rules/rule-group.model';
import { RuleGroupMappingFunctionality } from 'app/admin/rules/rule-group-functionality.model';
import { Rule } from 'app/admin/rules/rule.model';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

/**
* Service to manage all the rule related rest integrations.
*
* @author mohit.khurana@vernuso.com (Mohit Khurana)
*/
@Injectable()
export class RuleManagementService {
    constructor(private requestService: ObservableRequestService) { }

    getRuleGroup(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.RULE_GROUP)
            .map(response => {
                return plainToClass(RuleGroup, response.arrResult as Object[]);
            });
    }

    addRuleGroup(ruleGroup: Object): Observable<any> {
        return this.requestService.postRequest(ConstantsService.RULE_GROUP,
            JSON.stringify(ruleGroup),
            this.requestService.getJSONContentType());
    }

    addRule(rules: Object): Observable<any> {
        return this.requestService.postRequest(ConstantsService.RULE,
            JSON.stringify(rules),
            this.requestService.getJSONContentType());
    }

    validateRule(rules: Object): Observable<any> {
        return this.requestService.postRequest(ConstantsService.RULE_VALIDATE,
            JSON.stringify(rules),
            this.requestService.getJSONContentType());
    }

    getRuleGroupMappingFunctionality(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.RULE_GROUP_MAPPING)
            .map(response => {
                return plainToClass(RuleGroupMappingFunctionality, response.arrResult as Object[]);
            });
    }

    addRuleGroupMappingFunctionality(rulegroupmappingfunctionality: Object): Observable<any> {
        return this.requestService.postRequest(ConstantsService.RULE_GROUP_MAPPING,
            JSON.stringify(rulegroupmappingfunctionality),
            this.requestService.getJSONContentType());
    }

    deleteRuleGroupFunctionality(ruleGroupFuncId: number): Observable<any> {
        const deleteRuleGroupFuncUrl = ConstantsService.RULE_GROUP_MAPPING + '/' + ruleGroupFuncId;
        return this.requestService.deleteRequest(
            deleteRuleGroupFuncUrl,
            this.requestService.serialize(''),
            this.requestService.getJSONContentType());
    }

    deleteRule(ruleId: number): Observable<any> {
        const deleteRuleUrl = ConstantsService.RULE + '/' + ruleId;
        return this.requestService.deleteRequest(
            deleteRuleUrl,
            this.requestService.serialize(''),
            this.requestService.getJSONContentType());
    }

    deleteRuleGroup(groupId: number): Observable<any> {
        const deleteRuleGroupUrl = ConstantsService.RULE_GROUP + '/' + groupId;
        return this.requestService.deleteRequest(
            deleteRuleGroupUrl,
            this.requestService.serialize(''),
            this.requestService.getJSONContentType());
    }

    getRule(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.RULE)
            .map(response => {
                return plainToClass(Rule, response.arrResult as Object[]);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rule-management.service.ts